import React, { useState, useContext } from "react";
import { Card, Modal } from "antd";
import { FormattedMessage } from "react-intl";
import { SaveOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";

import AsRunSectionFormItem from "./AsRunSectionFormItem";

import SectionSwitch from "../../../Fields/SectionSwitch";
import EnginePlayoutElement from "../../../EnginePlayoutElement";

import { FormV5Context } from "../../NodeChannelFormV5";

import useNodeChannelConfig from "../../../../hooks/useNodeChannelConfig";

export default function AsRunSection({ disabled, handleFinish }) {
  const [open, setOpen] = useState(false);
  const form = useContext(FormV5Context);

  const { channelConfig, asRun } = useNodeChannelConfig();

  const { resetFields, getFieldValue, validateFields } = form;

  const handleSaveAsRun = async () => {
    await validateFields();
    const formData = getFieldValue("asRun");
    handleFinish({ ...channelConfig, asRun: formData });
    setOpen(false);
  };

  return (
    <Card
      title={
        <>
          <FormattedMessage id="AsRunSection.asRun" defaultMessage="AsRun" />{" "}
          <SectionSwitch
            prefix={["asRun", "enabled"]}
            disabled={disabled}
            handleFinish={handleFinish}
            handleOpen={() => setOpen(true)}
          />
        </>
      }
    >
      {asRun?.enabled && (
        <EnginePlayoutElement
          label={<FormattedMessage id="AsRunSection.asRun" defaultMessage="AsRun" />}
          handleClick={() => setOpen(true)}
          data={asRun}
        />
      )}
      <Modal
        title={<FormattedMessage id="AsRunSection.asRun" defaultMessage="AsRun" />}
        centered
        destroyOnClose
        open={open}
        onCancel={() => {
          resetFields();
          setOpen(false);
        }}
        onOk={handleSaveAsRun}
        width={1280}
        footer={disabled ? null : undefined}
        okText={
          <span>
            <FormattedMessage id="general.save" defaultMessage="Save" />
          </span>
        }
        okButtonProps={{ icon: <SaveOutlined /> }}
      >
        <AsRunSectionFormItem prefix={["asRun"]} disabled={disabled} />
      </Modal>
    </Card>
  );
}

AsRunSection.propTypes = {
  disabled: PropTypes.bool.isRequired,
  handleFinish: PropTypes.func.isRequired,
};
